import script from "./AppSidebarr.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebarr.vue?vue&type=script&setup=true&lang=js"

import "./AppSidebarr.vue?vue&type=style&index=0&id=39d095dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d095dc"]])

export default __exports__